import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const GrayscaleEnNoveltyLogoIcon = memo<ISvgProps>((props, { className }) => (
  <Svg
    className={className}
    id="en-novelty"
    xmlns="http://www.w3.org/2000/svg"
    width="240"
    height="72"
    viewBox="0 0 240 72"
    {...props}
  >
    <rect id="Rectangle_6045" data-name="Rectangle 6045" width="240" height="72" fill="none" />
    <g id="Group_17796" data-name="Group 17796" transform="translate(3.338 16)">
      <path
        id="Subtraction_1"
        data-name="Subtraction 1"
        d="M24,48A24.006,24.006,0,0,1,14.657,1.887,24.006,24.006,0,0,1,33.341,46.115,23.851,23.851,0,0,1,24,48ZM15.107,27.344,9.953,29.3a15.018,15.018,0,0,0,28.1-.024l-5.158-1.943a9.506,9.506,0,0,1-17.786.014Z"
        transform="translate(0.001 -0.001)"
        fill="#848ea9"
      />
      <path
        id="Path_23972"
        data-name="Path 23972"
        d="M16.659,6.454V1.517H7.048V-2.96h8.689V-7.535H7.048v-4.443h9.578v-4.9H1.848V6.454Zm8.986-9.381a2.655,2.655,0,0,1,2.7-2.864A2.534,2.534,0,0,1,31.01-2.96V6.454h5V-3.815c0-3.588-1.843-6.517-5.957-6.517a5.361,5.361,0,0,0-4.575,2.3V-9.9H20.642V6.454h5ZM49.376-1.215V-5.724H39.5v4.509ZM73.667,6.454V-16.882h-5.2V-2.7L59.711-16.882h-6.32V6.454h5.168V-8.884L68.17,6.454ZM85.713,2.34c-1.876,0-3.686-1.349-3.686-4.081,0-2.765,1.81-4.048,3.686-4.048,1.909,0,3.686,1.284,3.686,4.048S87.622,2.34,85.713,2.34Zm0-12.738a8.452,8.452,0,0,0-8.689,8.656,8.479,8.479,0,0,0,8.689,8.689A8.46,8.46,0,0,0,94.4-1.742,8.433,8.433,0,0,0,85.713-10.4ZM113.23-9.9h-5.266L104.474.266,100.689-9.9H95.258l6.714,16.358h5.036Zm5.826,6.221a3.116,3.116,0,0,1,3.259-2.765c2.37,0,3.226,1.514,3.291,2.765ZM125.967.562A3.16,3.16,0,0,1,122.676,2.7a3.541,3.541,0,0,1-3.719-3.16h11.388a10.441,10.441,0,0,0,.1-1.547c0-5.266-3.127-8.393-8.2-8.393a8.252,8.252,0,0,0-8.163,8.624,8.33,8.33,0,0,0,8.525,8.722c4.147,0,6.747-2.37,7.537-5.2Zm12.7,5.892v-23.83h-5V6.454Zm10.4-21.131H144.6v2.107A2.4,2.4,0,0,1,142.062-9.9h-.823v4.378h2.9V1.484c0,3.259,2.074,5.266,5.464,5.266a5.952,5.952,0,0,0,2.6-.461V2.142a6.17,6.17,0,0,1-1.317.165c-1.086,0-1.81-.362-1.81-1.712V-5.527h3.193V-9.9h-3.193ZM162.7,12.74,172.771-9.9h-5.3l-3.621,8.755L159.869-9.9h-5.6l6.879,14.153-3.719,8.492Z"
        transform="translate(60.552 30.614)"
        fill="#848ea9"
      />
    </g>
  </Svg>
));

GrayscaleEnNoveltyLogoIcon.displayName = 'GrayscaleEnNoveltyLogoIcon';

export default GrayscaleEnNoveltyLogoIcon;
